import React, { useState } from "react";

import { combineClassNames } from "../../utils/appUtils";

import IconButton from "../../packages/IconButton";
import { WarningOutlineIcon } from "../../packages/SVGs";
import { WPTypography } from "../../packages/WPTypography";

import CloseIcon from "../../common/icons/CloseIcon";
import InfoIcon from "../../common/icons/InfoIcon";

import "./WPMessageBanner.scss";

/**
 * @typedef {"error" | "warning" | "info"} Type
 */

export const BANNER_TYPES = {
  error: "error",
  warning: "warning",
  info: "info",
};

const ICON_TYPES = {
  error: <WarningOutlineIcon />,
  warning: <WarningOutlineIcon />,
  info: <InfoIcon />,
};

/**
 * WPMessageBanner component
 * @param {Object} props
 * @param {string} [props.id]
 * @param {Type} [props.type="error"]
 * @param {string} props.message
 * @param {string} [props.className]
 * @param {number} [props.fontSize]
 * @param {string} [props.textClassName]
 * @param {boolean} [props.dismissable=false] - Whether the banner can be dismissed
 */
const WPMessageBanner = ({
  message,
  type = BANNER_TYPES.error,
  className = "",
  fontSize,
  textClassName,
  dismissable = false,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={combineClassNames("wp-message-banner", type, className)}>
      {ICON_TYPES[type]}
      <WPTypography
        text={message}
        fontSize={fontSize || 14}
        className={combineClassNames(`${type}-text`, "flex-1", textClassName)}
        asElement="div"
      />
      {/* TODO: Localize tooltip */}
      {dismissable && (
        <IconButton
          className="wp-message-banner-close"
          tooltip="dismiss"
          onClick={() => setIsVisible(false)}
        >
          <CloseIcon fillOpacity={0.8} />
        </IconButton>
      )}
    </div>
  );
};

export default WPMessageBanner;
